<script setup lang="ts">
	const profile = ref({})

	const cachedData = useNuxtData('profile')
	if (cachedData.data.value && cachedData.data.value.info.count === 1) {
		profile.value = cachedData.data.value.items[0]
	}
</script>

<template>
	<template v-if="profile?.footer_link_groups_display">
		<div v-for="(group,idx) in profile.footer_link_groups_display" :key="'grp-'+idx">
			<span class="font-league-gothic text-primary font-medium uppercase text-[2rem] xs:text-[2.25rem] lg:text-[1.875rem] xl:text-[2.75rem] 2xl:text-[3rem] tracking-normal text-center md:text-left block mb-2">
				{{ group.title }}
			</span>
			<ul v-if="group.items?.length" class="space-y-2.5 mb-8 md:mb-0">
				<li v-for="(item,idx) in group.items" class="text-center md:text-left">
					<a v-if="item.url && item.url.startsWith('http')" :href="item.url" target="_blank" class="text-black hover:text-accent transition duration-300 ease-in-out" :title="item.tooltip ? item.tooltip : item.title">{{ item.title }}</a>
					<NuxtLink v-else-if="item.url" :to="item.url" class="text-black hover:text-accent transition duration-300 ease-in-out" :title="item.tooltip ? item.tooltip : item.title">
						{{ item.title }}
					</NuxtLink>
				</li>
			</ul>
		</div>
	</template>
</template>
